import ImageLayout, { Container } from 'components/ImageLayout';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import StripeProvider from 'components/StripeProvider';
import CreditCardPaymentType from './CreditCardPaymentType';
import DebitCardPaymentType from './DebitCardPaymentType';
import InvoiceRedirectPage from '../InvoiceRedirectPage';

const PaymentTypeLayout = () => (
  <StripeProvider>
    <ImageLayout direction="column">
      <Container>
        <Routes>
          <Route path="/:guid/credit-card" element={<CreditCardPaymentType />} />
          <Route path="/:guid/debit-card" element={<DebitCardPaymentType />} />
          <Route path="/:guid" element={<InvoiceRedirectPage />} />
          <Route path="/*" element={<Navigate to="/" />} />
        </Routes>
      </Container>
    </ImageLayout>
  </StripeProvider>
);

export default PaymentTypeLayout;
